/**
 *
 * @param {PropertyPureProps} property
 * @param {SVGOffsetProps} offset
 * @param {Number} lastX
 * @param {Number} lastY
 * @param {PropertyPureProps} value
 */
const setPointRotation = (property, offset, lastX, lastY, value) => {
  const lastRotation = property.get("last-point-rotation");
  const computed = offset.computed;

  let rotation =
    (Math.atan2(computed.y - lastY, computed.x - lastX) * 180) / Math.PI;

  if (!lastX || !lastY || !rotation) {
    return;
  }

  let angle = `${rotation || lastRotation || 0}deg`;

  if (rotation === 180) {
    rotation = lastRotation;
    angle = `${rotation}deg`;
  }

  if (rotation) {
    property.set("last-point-rotation", rotation);
  }

  offset.rotation = rotation;

  value.set("v_output", angle);
}

export default setPointRotation;